import { Button, useGetOne } from "react-admin";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { useState } from "react";
import { useWatch, useFormContext } from "react-hook-form";
import ProductInput from "../../purchaseOrders/common/ProductInput";

const ProductSelectionDialog = ({
  open,
  onClose,
  onOpenSaleRanking,
  productIdSource,
  productNameSource,
  fieldSources,
}) => {
  const { setValue } = useFormContext();
  const [selectionMode, setSelectionMode] = useState("manual");
  const pickerSource = `${productIdSource}__product_picker`;
  const selectedId = useWatch({ name: pickerSource });
  const { data: selectedProduct } = useGetOne(
    "products",
    { id: selectedId },
    { enabled: Boolean(selectedId) }
  );

  const handleUseProduct = () => {
    if (!selectedProduct?.code) return;

    const tenCode = selectedProduct.code.slice(0, 10);

    setValue(productIdSource, tenCode, {
      shouldDirty: true,
      shouldTouch: true,
      shouldValidate: true,
    });
    if (productNameSource) {
      setValue(productNameSource, selectedProduct.name || "", {
        shouldDirty: true,
        shouldTouch: true,
      });
    }
    Object.values(fieldSources).forEach((source) => {
      setValue(source, 0, { shouldDirty: true, shouldTouch: true });
    });
    if (fieldSources.dayRange) {
      setValue(fieldSources.dayRange, 1, {
        shouldDirty: true,
        shouldTouch: true,
        shouldValidate: true,
      });
    }
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Pilih Produk</DialogTitle>
      
      {/* Tab Selection */}
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs 
          value={selectionMode} 
          onChange={(e, newValue) => setSelectionMode(newValue)}
          aria-label="Pilihan metode seleksi produk"
        >
          <Tab label="Seluruh Produk" value="manual" />
          <Tab label="Sale Ranking" value="ranking" />
        </Tabs>
      </Box>

      <DialogContent>
        {selectionMode === "manual" && (
          <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}>
            <Box sx={{ flex: 1 }}>
              <ProductInput
                source={pickerSource}
                label="mine.label.product_code"
                optionText={(record) => record.code?.slice(0, 10) || ""}
                defaultFilters={{ "products.active": 1 }}
                withCreate={false}
                fullWidth
                variant="outlined"
              />
            </Box>
          </Box>
        )}

        {selectionMode === "ranking" && (
          <Box sx={{ py: 2, textAlign: "center", color: "text.secondary" }}>
            <p>Gunakan tombol "Lanjut dengan Sale Ranking" di bawah untuk memilih produk berdasarkan ranking penjualan</p>
          </Box>
        )}
      </DialogContent>

      <DialogActions sx={{ display: "flex", justifyContent: "flex-end", gap: 1, px: 2, pb: 2 }}>
        <Button label="mine.label.cancel" onClick={onClose} />
        
        {selectionMode === "manual" && (
          <Button
            label="mine.label.select"
            onClick={handleUseProduct}
            disabled={!selectedProduct?.code}
          />
        )}

        {selectionMode === "ranking" && (
          <Button
            label="Lanjut dengan Sale Ranking"
            onClick={() => {
              onClose();
              onOpenSaleRanking();
            }}
          />
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ProductSelectionDialog;
